import { atom } from 'recoil';

export const manageConsulteesUserTableEditingRowState = atom<number | undefined>({
  key: 'manageConsulteesUserTableEditingRow',
  default: undefined,
});
